import { EXPERIENCES, NEARBY } from "../../data/content";
import { MapPin, ArrowUpRight } from "lucide-react";

export default function ThingsToDo() {
  return (
    <section
      id="things-to-do"
      data-testid="things-to-do-section"
      className="py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-7">
            <p className="section-eyebrow">
              <span className="divider-rule" /> Things To Do
            </p>
            <h2
              className="mt-5 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05]"
              style={{ color: "var(--dl-ink)", fontWeight: 400 }}
            >
              A wonderful base to explore
              <br />
              <span className="serif-italic">the Cheshire countryside.</span>
            </h2>
          </div>
          <p
            className="lg:col-span-5 self-end text-base leading-relaxed"
            style={{ color: "var(--dl-ink-2)" }}
          >
            Walks straight from the doorstep along the River Weaver. Cycling tracks
            for miles in every direction. Welcoming country pubs, the Anderton Boat
            Lift, Delamere Forest and Arley Hall all within easy reach.
          </p>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
          {EXPERIENCES.map((e, i) => (
            <article
              key={e.title}
              data-testid={`experience-card-${i}`}
              className="property-card fade-up"
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="media-zoom aspect-[4/5] w-full">
                <img
                  src={e.image}
                  alt={e.title}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 flex flex-col gap-3">
                <h3
                  className="font-serif text-2xl tracking-tight"
                  style={{ color: "var(--dl-ink)", fontWeight: 500 }}
                >
                  {e.title}
                </h3>
                <p
                  className="text-[0.92rem] leading-relaxed"
                  style={{ color: "var(--dl-ink-2)" }}
                >
                  {e.body}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div
          className="mt-20 grid lg:grid-cols-12 gap-10 items-start"
          data-testid="nearby-list"
        >
          <div className="lg:col-span-5">
            <p className="section-eyebrow">
              <span className="divider-rule" /> Nearby
            </p>
            <h3
              className="mt-4 font-serif text-3xl sm:text-4xl tracking-tight"
              style={{ color: "var(--dl-ink)", fontWeight: 400 }}
            >
              Worth the short drive
            </h3>
          </div>
          <ul className="lg:col-span-7 grid sm:grid-cols-2 gap-x-8 gap-y-1">
            {NEARBY.map((n) => (
              <li
                key={n.label}
                className="group"
                style={{
                  borderBottom: "1px solid var(--dl-border)",
                }}
              >
                <a
                  href={n.url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`nearby-link-${n.label.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                  className="flex items-start gap-3 py-3 transition-colors hover:text-[color:var(--dl-accent)]"
                  style={{ color: "var(--dl-ink)" }}
                >
                  <MapPin
                    size={14}
                    className="mt-1 shrink-0"
                    style={{ color: "var(--dl-accent)" }}
                  />
                  <span className="text-[0.95rem] flex-1">{n.label}</span>
                  <ArrowUpRight
                    size={14}
                    className="mt-1 shrink-0 opacity-50 group-hover:opacity-100 transition-opacity"
                  />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
